import "./TabsContainer.scss";

interface TabsContainerProps {
  darkTheme?: boolean;
  isUserTipping?: boolean;
  tabList: string[];
  contentList: JSX.Element[];
  currentTab: number;
  onSwitchTab?: (tabIdx: number) => void;
}

const TabsContainer = (props: TabsContainerProps) => {
  return (
    <div className={"tab-wrapper" + (props.darkTheme ? " dark" : "")}>
      {!props.isUserTipping && (
        <div className="tabs">
          {props.tabList.map((tab, idx) => (
            <label
              key={"tab-label-" + idx}
              className={"tab" + (idx === props.currentTab ? " active" : "")}
              htmlFor={"tab-radiobtn-" + idx}
              onClick={() => {
                if (idx !== props.currentTab && props.onSwitchTab)
                  props.onSwitchTab(idx);
              }}
            >
              {tab}
            </label>
          ))}
        </div>
      )}
      <div className="panels">
        {props.contentList.map((child, idx) => (
          <div
            key={"tab-content-" + idx}
            className={"panel" + (idx === props.currentTab ? " active" : "")}
            id={"tab-content-" + idx}
          >
            {child}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TabsContainer;
